import api from './api.service';
import apiRoutes from './api.routes';
import dih from '../helpers/defaultImages.helper';
import fh from '../helpers/file.helper';

const get = async () => api.catchError(async () => {
  const { data } = await api.get(apiRoutes.profile);
  return data;
});

const update = async profile => api.catchError(async () => {
  const { data } = await api.put(apiRoutes.profile, profile);
  return data;
});

const getFilePathByDir = (dir, filename, w = false, h = false, c = false) => {
  if (!filename) return '';
  let prefix = '';
  const ext = filename.split('.').pop().toLowerCase();
  const images = ['jpg', 'jpeg', 'png', 'bmp'];
  if ((w || h) && images.includes(ext)) {
    prefix = `${w}_${h}_${(c ? 'c' : 'o')}_`;
  }
  return `${api.baseUrl}${dir}/${prefix}${filename}`;
};

const defaultLogo = dih.defaultLogoSite;

const getLogo = (filename, token, w = false, h = false, c = false) => {
  if (!filename) return '';
  if (Number(filename)) return fh.createLink(filename, token);
  return getFilePathByDir(`/uploads/${api.subdomain}/subscribers`, filename, w, h, c);
};

export default {
  get,
  update,
  getLogo,
  defaultLogo,
};



// WEBPACK FOOTER //
// ./src/services/profile.service.js